// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Lato', -apple-system, BlinkMacSystemFont, sans-serif;
  background: linear-gradient(135deg, #f0fdf4 0%, #ecfeff 50%, #fef3c7 100%);
  min-height: 100vh;
  overflow-x: hidden;
}

h1, h2, h3, h4 {
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.App {
  min-height: 100vh;
}

/* Enhanced buttons */
button {
  font-weight: 500;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 12px;
}

button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);
}

button:active:not(:disabled) {
  transform: translateY(0);
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Enhanced inputs */
input, textarea, select {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 10px;
}

input:focus, textarea:focus, select:focus {
  outline: none;
  border-color: #10b981;
  box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.1);
  transform: translateY(-1px);
}

/* Card enhancements */
.card-hover {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 16px;
}

.card-hover:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
}

/* Enhanced glassmorphism */
.glass {
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.04);
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-track {
  background: rgba(16, 185, 129, 0.05);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #10b981 0%, #059669 100%);
  border-radius: 10px;
  border: 2px solid transparent;
  background-clip: content-box;
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #059669 0%, #047857 100%);
  background-clip: content-box;
}

/* Loading animation */
@keyframes spin {
  to { transform: rotate(360deg); }
}

.animate-spin {
  animation: spin 1s linear infinite;
}

/* Enhanced fade in */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-in {
  animation: fadeInUp 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Pulse animation for important elements */
@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.8; }
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

/* Slide in from left */
@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.slide-in-left {
  animation: slideInLeft 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Gradient text */
.gradient-text {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Status badges */
.status-badge {
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.025em;
  text-transform: uppercase;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

/* Floating labels */
.floating-label {
  position: relative;
}

.floating-label input:focus + label,
.floating-label input:not(:placeholder-shown) + label {
  transform: translateY(-24px) scale(0.85);
  color: #10b981;
}

.floating-label label {
  position: absolute;
  left: 12px;
  top: 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: none;
  background: white;
  padding: 0 4px;
}

/* Dark mode enhancements */
.dark {
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%);
  color: #f1f5f9;
}

.dark .glass {
  background: rgba(30, 41, 59, 0.92);
  border: 1px solid rgba(148, 163, 184, 0.15);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.dark ::-webkit-scrollbar-track {
  background: rgba(16, 185, 129, 0.05);
}

.dark ::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #10b981 0%, #059669 100%);
}

/* Stat card specific styles */
.stat-card {
  position: relative;
  overflow: hidden;
}

.stat-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #10b981 0%, #059669 100%);
  transform: scaleX(0);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.stat-card:hover::before {
  transform: scaleX(1);
}

/* Icon backgrounds */
.icon-bg {
  position: relative;
  overflow: hidden;
}

.icon-bg::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: linear-gradient(135deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.icon-bg:hover::after {
  opacity: 1;
}

/* Form enhancements */
.form-input {
  border: 2px solid #e5e7eb;
  background: white;
}

.form-input:hover {
  border-color: #d1d5db;
}

.form-input:focus {
  border-color: #10b981;
  background: white;
}

/* Selection styling */
::selection {
  background: #10b981;
  color: white;
}

/* Skeleton loading */
@keyframes skeleton-loading {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}

.skeleton {
  background: linear-gradient(
    90deg,
    #f3f4f6 25%,
    #e5e7eb 50%,
    #f3f4f6 75%
  );
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s ease-in-out infinite;
  border-radius: 8px;
}

/* Tooltip styles */
.tooltip {
  position: relative;
}

.tooltip:hover::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  padding: 8px 12px;
  background: #1f2937;
  color: white;
  border-radius: 8px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 1000;
  margin-bottom: 8px;
}

/* Enhanced shadows */
.shadow-soft {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
}

.shadow-medium {
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}

.shadow-strong {
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}

/* Mobile-specific fixes - Prevent content overflow and overlapping */
@media (max-width: 768px) {
  /* Typography scaling */
  h1 { 
    font-size: 1.75rem; 
    line-height: 1.2;
    word-wrap: break-word;
  }
  h2 { 
    font-size: 1.35rem; 
    line-height: 1.3;
    word-wrap: break-word;
  }
  h3 {
    font-size: 1.1rem;
    line-height: 1.4;
  }
  
  /* Prevent text overflow */
  * {
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  /* Ensure content fits */
  .stat-card { 
    font-size: 0.875rem; 
    padding: 1rem;
  }
  
  /* Cards and containers */
  .card, [class*="Card"] {
    padding: 1rem;
    margin-bottom: 1rem;
  }
  
  /* Tables on mobile */
  table {
    font-size: 0.875rem;
  }
  
  /* Buttons */
  button {
    min-height: 44px; /* iOS touch target */
    padding: 0.75rem 1rem;
  }
  
  /* Forms */
  input, textarea, select {
    font-size: 16px; /* Prevent zoom on iOS */
    min-height: 44px;
  }
  
  /* Prevent horizontal scroll */
  body, html {
    overflow-x: hidden;
    max-width: 100vw;
  }
  
  /* Dialogs and modals */
  [role="dialog"], .dialog {
    max-width: 95vw !important;
    margin: 0.5rem;
  }
}

/* Extra small devices */
@media (max-width: 375px) {
  h1 { font-size: 1.5rem; }
  h2 { font-size: 1.25rem; }
  body { font-size: 0.9rem; }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,kEAAkE;EAClE,0EAA0E;EAC1E,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA,2BAA2B;AAC3B;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,6DAA6D;EAC7D,4BAA4B;AAC9B;;AAEA,sBAAsB;AACtB;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,qBAAqB;AACrB;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,qDAAqD;AACvD;;AAEA,2CAA2C;AAC3C;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,yDAAyD;AAC3D;;AAEA,uBAAuB;AACvB;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,wDAAwD;AAC1D;;AAEA,kBAAkB;AAClB;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;;AAEA;;EAEE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,iDAAiD;EACjD,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,0EAA0E;EAC1E,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,2CAA2C;EAC3C,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4DAA4D;EAC5D,oBAAoB;EACpB,uDAAuD;AACzD;;AAEA;EACE,oBAAoB;AACtB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,uFAAuF;EACvF,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,qEAAqE;AACrE;EACE,uBAAuB;EACvB;IACE,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA,0BAA0B;EAC1B;IACE,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA,wBAAwB;EACxB;IACE,mBAAmB;IACnB,aAAa;EACf;;EAEA,yBAAyB;EACzB;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA,qBAAqB;EACrB;IACE,mBAAmB;EACrB;;EAEA,YAAY;EACZ;IACE,gBAAgB,EAAE,qBAAqB;IACvC,qBAAqB;EACvB;;EAEA,UAAU;EACV;IACE,eAAe,EAAE,wBAAwB;IACzC,gBAAgB;EAClB;;EAEA,8BAA8B;EAC9B;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA,uBAAuB;EACvB;IACE,0BAA0B;IAC1B,cAAc;EAChB;AACF;;AAEA,wBAAwB;AACxB;EACE,KAAK,iBAAiB,EAAE;EACxB,KAAK,kBAAkB,EAAE;EACzB,OAAO,iBAAiB,EAAE;AAC5B","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700;900&display=swap');\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Lato', -apple-system, BlinkMacSystemFont, sans-serif;\n  background: linear-gradient(135deg, #f0fdf4 0%, #ecfeff 50%, #fef3c7 100%);\n  min-height: 100vh;\n  overflow-x: hidden;\n}\n\nh1, h2, h3, h4 {\n  font-family: 'Lato', sans-serif;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\n.App {\n  min-height: 100vh;\n}\n\n/* Enhanced buttons */\nbutton {\n  font-weight: 500;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  border-radius: 12px;\n}\n\nbutton:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);\n}\n\nbutton:active:not(:disabled) {\n  transform: translateY(0);\n}\n\nbutton:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Enhanced inputs */\ninput, textarea, select {\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  border-radius: 10px;\n}\n\ninput:focus, textarea:focus, select:focus {\n  outline: none;\n  border-color: #10b981;\n  box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.1);\n  transform: translateY(-1px);\n}\n\n/* Card enhancements */\n.card-hover {\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  border-radius: 16px;\n}\n\n.card-hover:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);\n}\n\n/* Enhanced glassmorphism */\n.glass {\n  background: rgba(255, 255, 255, 0.92);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.04);\n}\n\n/* Custom scrollbar */\n::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background: rgba(16, 185, 129, 0.05);\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: linear-gradient(180deg, #10b981 0%, #059669 100%);\n  border-radius: 10px;\n  border: 2px solid transparent;\n  background-clip: content-box;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: linear-gradient(180deg, #059669 0%, #047857 100%);\n  background-clip: content-box;\n}\n\n/* Loading animation */\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.animate-spin {\n  animation: spin 1s linear infinite;\n}\n\n/* Enhanced fade in */\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.fade-in {\n  animation: fadeInUp 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Pulse animation for important elements */\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.8; }\n}\n\n.animate-pulse {\n  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n/* Slide in from left */\n@keyframes slideInLeft {\n  from {\n    opacity: 0;\n    transform: translateX(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.slide-in-left {\n  animation: slideInLeft 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Gradient text */\n.gradient-text {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Status badges */\n.status-badge {\n  padding: 6px 14px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.025em;\n  text-transform: uppercase;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n/* Floating labels */\n.floating-label {\n  position: relative;\n}\n\n.floating-label input:focus + label,\n.floating-label input:not(:placeholder-shown) + label {\n  transform: translateY(-24px) scale(0.85);\n  color: #10b981;\n}\n\n.floating-label label {\n  position: absolute;\n  left: 12px;\n  top: 12px;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  pointer-events: none;\n  background: white;\n  padding: 0 4px;\n}\n\n/* Dark mode enhancements */\n.dark {\n  background: linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%);\n  color: #f1f5f9;\n}\n\n.dark .glass {\n  background: rgba(30, 41, 59, 0.92);\n  border: 1px solid rgba(148, 163, 184, 0.15);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n}\n\n.dark ::-webkit-scrollbar-track {\n  background: rgba(16, 185, 129, 0.05);\n}\n\n.dark ::-webkit-scrollbar-thumb {\n  background: linear-gradient(180deg, #10b981 0%, #059669 100%);\n}\n\n/* Stat card specific styles */\n.stat-card {\n  position: relative;\n  overflow: hidden;\n}\n\n.stat-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #10b981 0%, #059669 100%);\n  transform: scaleX(0);\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.stat-card:hover::before {\n  transform: scaleX(1);\n}\n\n/* Icon backgrounds */\n.icon-bg {\n  position: relative;\n  overflow: hidden;\n}\n\n.icon-bg::after {\n  content: '';\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: linear-gradient(135deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 100%);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.icon-bg:hover::after {\n  opacity: 1;\n}\n\n/* Form enhancements */\n.form-input {\n  border: 2px solid #e5e7eb;\n  background: white;\n}\n\n.form-input:hover {\n  border-color: #d1d5db;\n}\n\n.form-input:focus {\n  border-color: #10b981;\n  background: white;\n}\n\n/* Selection styling */\n::selection {\n  background: #10b981;\n  color: white;\n}\n\n/* Skeleton loading */\n@keyframes skeleton-loading {\n  0% { background-position: -200% 0; }\n  100% { background-position: 200% 0; }\n}\n\n.skeleton {\n  background: linear-gradient(\n    90deg,\n    #f3f4f6 25%,\n    #e5e7eb 50%,\n    #f3f4f6 75%\n  );\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s ease-in-out infinite;\n  border-radius: 8px;\n}\n\n/* Tooltip styles */\n.tooltip {\n  position: relative;\n}\n\n.tooltip:hover::after {\n  content: attr(data-tooltip);\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 8px 12px;\n  background: #1f2937;\n  color: white;\n  border-radius: 8px;\n  font-size: 12px;\n  white-space: nowrap;\n  z-index: 1000;\n  margin-bottom: 8px;\n}\n\n/* Enhanced shadows */\n.shadow-soft {\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);\n}\n\n.shadow-medium {\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);\n}\n\n.shadow-strong {\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);\n}\n\n/* Mobile-specific fixes - Prevent content overflow and overlapping */\n@media (max-width: 768px) {\n  /* Typography scaling */\n  h1 { \n    font-size: 1.75rem; \n    line-height: 1.2;\n    word-wrap: break-word;\n  }\n  h2 { \n    font-size: 1.35rem; \n    line-height: 1.3;\n    word-wrap: break-word;\n  }\n  h3 {\n    font-size: 1.1rem;\n    line-height: 1.4;\n  }\n  \n  /* Prevent text overflow */\n  * {\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n  }\n  \n  /* Ensure content fits */\n  .stat-card { \n    font-size: 0.875rem; \n    padding: 1rem;\n  }\n  \n  /* Cards and containers */\n  .card, [class*=\"Card\"] {\n    padding: 1rem;\n    margin-bottom: 1rem;\n  }\n  \n  /* Tables on mobile */\n  table {\n    font-size: 0.875rem;\n  }\n  \n  /* Buttons */\n  button {\n    min-height: 44px; /* iOS touch target */\n    padding: 0.75rem 1rem;\n  }\n  \n  /* Forms */\n  input, textarea, select {\n    font-size: 16px; /* Prevent zoom on iOS */\n    min-height: 44px;\n  }\n  \n  /* Prevent horizontal scroll */\n  body, html {\n    overflow-x: hidden;\n    max-width: 100vw;\n  }\n  \n  /* Dialogs and modals */\n  [role=\"dialog\"], .dialog {\n    max-width: 95vw !important;\n    margin: 0.5rem;\n  }\n}\n\n/* Extra small devices */\n@media (max-width: 375px) {\n  h1 { font-size: 1.5rem; }\n  h2 { font-size: 1.25rem; }\n  body { font-size: 0.9rem; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
